(() => {
  if (window.regionSelectorInitialized) return;
  window.regionSelectorInitialized = true;

  const openSelector = (selector) => {
    if (!selector || typeof selector.open !== 'function') return;
    selector.open();
  };

  const closeSelector = (selector) => {
    if (!selector || typeof selector.close !== 'function') return;
    selector.close();
  };

  class RegionSelector extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.region-selector__dialog');
      this.previousFocus = null;

      this.querySelectorAll('[data-region-selector-close]').forEach((element) => {
        element.addEventListener('click', () => this.close());
      });

      this.querySelectorAll('[data-region-site]').forEach((element) => {
        element.addEventListener('click', () => this.close());
      });
    }

    open() {
      if (!this.dialog) return;

      this.previousFocus = document.activeElement;
      document.querySelectorAll('[data-region-selector-open]').forEach((trigger) => {
        if (trigger.dataset.regionSelectorOpen === this.id) trigger.setAttribute('aria-expanded', 'true');
      });
      this.hidden = false;
      document.body.classList.add('region-selector-open');
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        this.dialog.focus({ preventScroll: true });
      });
    }

    close() {
      if (!this.dialog || this.hidden) return;

      this.classList.remove('is-open');
      document.body.classList.remove('region-selector-open');
      document.querySelectorAll('[data-region-selector-open]').forEach((trigger) => {
        if (trigger.dataset.regionSelectorOpen === this.id) trigger.setAttribute('aria-expanded', 'false');
      });
      window.setTimeout(() => {
        if (!this.classList.contains('is-open')) this.hidden = true;
      }, 180);

      if (this.previousFocus && typeof this.previousFocus.focus === 'function') {
        this.previousFocus.focus({ preventScroll: true });
      }
    }
  }

  if (!customElements.get('region-selector')) customElements.define('region-selector', RegionSelector);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-region-selector-open]');
    if (!trigger) return;

    event.preventDefault();
    const menuDrawer = document.getElementById('MenuDrawer');
    if (menuDrawer?.open && typeof menuDrawer.hide === 'function') menuDrawer.hide();
    openSelector(document.getElementById(trigger.dataset.regionSelectorOpen));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('region-selector.is-open').forEach((selector) => closeSelector(selector));
  });
})();
